import { render, staticRenderFns } from "./CreateNetGsmChannel.vue?vue&type=template&id=675259b0&scoped=true"
import script from "./CreateNetGsmChannel.vue?vue&type=script&lang=js"
export * from "./CreateNetGsmChannel.vue?vue&type=script&lang=js"
import style0 from "./CreateNetGsmChannel.vue?vue&type=style&index=0&id=675259b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675259b0",
  null
  
)

export default component.exports